import { render } from "./courseInfo.vue?vue&type=template&id=b23f7a64&scoped=true"
import script from "./courseInfo.vue?vue&type=script&lang=js"
export * from "./courseInfo.vue?vue&type=script&lang=js"

import "./courseInfo.vue?vue&type=style&index=0&id=b23f7a64&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23f7a64"]])

export default __exports__